<template>
  <div>
    <p class="text-uppercase text-muted sectionheader">{{$lang('services')}}</p>
    <div class="services">
      <div class="tilecontainer1 d-flex flex-row justify-content-center flex-wrap">
        <a v-if='options.messagesfromspv||options.mail' href="/#/mail" class="tile bigtile messages">
          <h4 class="px-4 py-4 text-white">{{$lang('mymail')}}</h4>
          
            <div class="d-flex flex-row justify-content-end px-4 py-4">
              <transition name="fade">
              <div v-if='messages.count > 0' class="messagescounter">
                <i class="fa fa-envelope-o"></i>
                {{messages.count}}
              </div>
              <div v-if='messages.count === 0' class="messagesno">
                {{$lang('nonewmessages')}}
              </div>
              </transition>              
              <b-spinner v-if='messages.count === -1' small></b-spinner>
            </div>
          
        </a>
        <div class="tinygroup d-flex flex-column flex-wrap">
          <a href="/#/aproposals" class="tile smalltile aproposals d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-bicycle"></i>
            <p class="text-center">{{$lang('aproposals')}}</p>
          </a>
          <a v-if='options.lunches' href="/#/lunch" class="tile smalltile lunchorders d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-coffee"></i>
            <p class="text-center">{{$lang('lunch')}}</p>
          </a>
          <a v-if='options.timesheets' href="/#/timesheets" class="tile smalltile timesheets d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-clock-o"></i>
            <p class="text-center">{{$lang('timesheets')}}</p>
          </a>           
          <a href="/#/contact" class="tile smalltile callus d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-phone"></i>
            <p class="text-center">{{$lang('contacthr')}}</p>
          </a>
        </div>
      </div> 
      <!--
      <div class="tilecontainer2 d-flex justify-content-center flex-wrap">
          <a v-if='options.lunches' href="/#/lunch" class="tile smalltile lunchorders d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-coffee"></i>
            <p class="text-center">{{$lang('lunch')}}</p>
          </a>
          <a href="/#/aproposals" class="tile smalltile aproposals d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-bicycle"></i>
            <p class="text-center">{{$lang('aproposals')}}</p>
          </a>
          <a v-if='options.timesheets' href="/#/timesheets" class="tile smalltile timesheets d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-clock-o"></i>
            <p class="text-center">{{$lang('timesheets')}}</p>
          </a> 
          <a v-if='options.messagesfromspv' href="/#/mail" class="tile smalltile rincident d-flex flex-column align-items-center justify-content-center">
            <i class="fa fa-3x fa-exclamation"></i>
            <p class="text-center">{{$lang('messagesfromspv')}}</p>
          </a>
      </div>
      
      </div>
      -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: mapState(['messages','options']),
  mounted() {
    this.$store.dispatch('updateMessages');
  },
  data() {
    return {
      counter: null,
    }
  },
  locales: {
    en: {
      services: "Services",
      lunch: "Lunch Orders",
      aproposals: "Absence Proposals",
      incident: "Report an Incident",
      mymail: "My Messages",
      callus: "Call Us",
      serviceDesk: "Service Desk",
      hrPolicies: "HR Policies and Documentation",
      timesheets: "Time Sheets",
      nonewmessages: "No New Messages",
      contacthr: "Contact Human Resources"
    },
    de: {
      services: "Dienstleistungen",
      lunch: "Mittagessen Bestellungen",
      aproposals: "Abwesenheitsanträge",
      incident: "Einen Vorfall melden",
      mymail: "Meine Nachrichten",
      callus: "Rufen uns an",
      serviceDesk: "Serviceschalter",
      hrPolicies: "PA-Richtlinien und Dokumentation",
      timesheets: "Stundennachweis",
      nonewmessages: "Keine neuen Beiträge",
      contacthr: "Kontakt zur Personalabteilung"
    },
    ru: {
      services: "Сервисы",
      lunch: "Заказы обедов",
      aproposals: "Записи об отсутствии",
      incident: "Сообщить об инциденте",
      mymail: "Мои сообщения",
      callus: "Контакт центр",
      serviceDesk: "Служба поддержки",
      hrPolicies: "Документы от отдела кадров",
      timesheets: "Отчеты о рабочем времени",
      nonewmessages: "Нет новых сообщений",
      contacthr: "Связаться с отделом кадров"
    },
    pl: {
      services: "Usługi",
      lunch: "Zamówienia na lunch",
      aproposals: "Rejestry nieobecności",
      incident: "Zgłoś incydent",
      mymail: "Moje wiadomości",
      callus: "Zadzwoń do nas",
      serviceDesk: "Biuro obsługi",
      hrPolicies: "Dokumenty z działu HR",
      timesheets: "Raporty czasowe",
      nonewmessages: "Żadnych nowych wiadomości",
      contacthr: "Skontaktuj się z działem HR"
    }
  }
};
</script>

<style scoped>
.sectionheader {
  padding-left: 1rem;
  margin-bottom: 2rem;
  font-size: 12px;
}
.tile {
  text-decoration: none;
}
.tile:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.bigtile {
  background-color: cornflowerblue;
  width: 50%;
  height: 300px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.smalltile {
  max-width: 80%;
  width: 50%;
  min-width: 180px;
  height: 150px;
}
.servicedesk {
  background-image: url("/dist/servicedesk.jpg");
  background-repeat: no-repeat;
  background-color: #fff;
  background-position: right;
  color: #444;
}
.tilecontainer1 {
  width: 100%;
  min-height: 300px;
}
.tinygroup {
  width: 50%;
  height: 300px;
  min-width: 360px;
} 
.services {
  padding-left: 4rem;
  padding-right: 4rem;
  padding-bottom: 2rem;
}
.messages {
  background: #546ff9;
  background: -webkit-linear-gradient(top left, rgb(69, 90, 197), #31287d);
  background: -moz-linear-gradient(top left, rgb(69, 90, 197), #31287d);
  background: linear-gradient(to bottom right, rgb(69, 90, 197), #31287d);
}
.docs {
  background-color: cornflowerblue;
  color: #fff;
}
.callus {
  background-color: rgb(61, 83, 126);
  color: #fff;
}
.lunchorders {
  color: #eee;
  background-color: #6d2b8b;
}
.rincident {
  background-color: #2d3169;
  color: #eee;
}
.aproposals {
  background-color: darkseagreen;
  color: #444;
}
.timesheets
{
  background-color: #2d3169;
  color: #eee;
}
.messagescounter {
  color: #fafafa;
  font-size: 64px;
  font-weight: 100;
}
.messagesno{
  color: #b8b9bb;
  font-size: 14px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  animation: bounce-in 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/Services.vue